import { Dispatch, SetStateAction } from 'react';
import { Column } from 'react-table';

import ImportTable from 'coreOld/components/ImportTable';
import { TableNames } from 'coreOld/constants';
import { Checkbox } from 'coreOld/elements';
import { IPill } from 'partsOld/types';

import {
  ModalWrapper,
  Space,
  tableBodyStyle,
  TableWrapper,
  Wrapper,
} from './importTableModalStyle';
import PillList from '../PillList';

interface IProps {
  isUploadSuccessful: boolean;
  initialPills: IPill[];
  clearHeaders: () => void;
  onCheckboxChange: (isPricing: boolean) => void;
  isLoading: boolean;
  pricingCheckbox: boolean;
  quantityCheckbox: boolean;
  setAddNewHeader: Dispatch<SetStateAction<boolean>>;
  addNewHeader: boolean;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage;
  columns: Column<object>[];
  records: Array<Array<string>>;
  onConfirmMapping: () => Promise<void>;
}

const ImportTableModalView = ({
  initialPills,
  clearHeaders,
  onCheckboxChange,
  columns,
  records,
  isLoading,
  pricingCheckbox,
  quantityCheckbox,
  setAddNewHeader,
  addNewHeader,
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
  onConfirmMapping,
}: IProps) => {
  return (
    <ModalWrapper>
      <PillList
        initialPills={initialPills}
        clearHeaders={clearHeaders}
        onCheckboxChange={onCheckboxChange}
        pricingCheckbox={pricingCheckbox}
        quantityCheckbox={quantityCheckbox}
        onConfirmMapping={onConfirmMapping}
        isLoading={isLoading}
      />

      <Wrapper>
        <Checkbox
          label="Add header row"
          checked={addNewHeader}
          onChange={() => setAddNewHeader((prev) => !prev)}
        />

        <Space />

        <TableWrapper>
          <ImportTable
            columns={columns || []}
            data={records}
            headerLines={2}
            name={TableNames.IMPORT_PARTS}
            isLoading={isLoading}
            tableBodyStyle={tableBodyStyle}
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            fetchNextPage={fetchNextPage}
          />
        </TableWrapper>
      </Wrapper>
    </ModalWrapper>
  );
};

export default ImportTableModalView;
